import api from "./api";
import endpoints from "./endpoints";

export default {
  get: async function () {
    const response = await api.get(endpoints.article.articleNumberTypes.get);
    return response.data;
  }
};
